<script setup>
import Close from '~/assets/icons/close.svg'

defineProps({
    visible: {
        type: Boolean,
        required: true,
        default: false
    }
})

const emit = defineEmits(['update:toggleDialog'])
</script>

<template>
    <dialog v-if="visible" :open="visible" class="content-modal" @click.self="emit('update:toggleDialog', false)">
        <div class="content-modal-container">
            <div class="content-modal-inner">
                <slot />
                <button class="content-modal-close" @click="emit('update:toggleDialog', false)">
                    <component :is="Close" />
                </button>
            </div>
        </div>
    </dialog>
</template>

<style lang="scss">
.content-modal {
    position: fixed;
    inset: 0;
    padding: 1rem;
    z-index: z('content-modal');
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100dvw;
    height: 100dvh;
    background-color: $content-modal-bg;
    backdrop-filter: blur(7px);
}

.content-modal-container {
    position: relative;
    height: 100vh;
    display: flex;

    @include scrollbar;

    .app-download-invite {
        margin: 0;
    }
}

.content-modal-inner {
    margin: auto;
    position: relative;
}

.content-modal-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    padding: 0;
    background-color: transparent;
    border: none;
    color: $content-modal-close;
    cursor: pointer;
    z-index: 3;
    transition: color 400ms ease-in-out;

    &:hover {
        color: $content-modal-close-hover;
    }

    svg {
        width: 14px;
        height: auto;
    }
}
</style>
